import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
// import ProductSection from "./ProductSection";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";

const VarientSection = ({
  product_id,
  weekIndex,
  control,
  register,
  getValues,
  errors,
  watch,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `quantitys.${weekIndex}.varients`,
  });

  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };
  useEffect(() => {
    getAllCategories();
    getAllDays();
  }, []);

  const [productVarient, setProductVarient] = useState([]);

  const Select2Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      price: data?.price,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const GetAllProductVarient = async (id) => {
    const response = await getData(
      `/common/masters/product-varient/${product_id?.value}`
    );

    if (response?.success) {
      setProductVarient(await Select2Data(response?.data, "varient_id"));
    }
  };

  useEffect(() => {
    GetAllProductVarient();
  }, [product_id?.value]);



  return (
    <>
      {productVarient.map((variant, deliveryIndex) => (
        <div key={variant.value} className="border p-3 mb-3">
          <Row>
            <h5>Variant {deliveryIndex + 1}</h5>

            {/* Hidden field to store varient_id */}
            <Controller
              control={control}
              name={`quantitys.${weekIndex}.varients.${deliveryIndex}.varient_id`}
              defaultValue={variant.value}
              render={({ field }) => <input type="hidden" {...field} />}
            />

            <Col md={4}>
              <Form.Group>
                <Form.Label>Variant</Form.Label>

                <Form.Control type="text" value={variant.label} readOnly />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Selling Price</Form.Label>
                <Controller
                  control={control}
                  name={`quantitys.${weekIndex}.varients.${deliveryIndex}.selling_price`}
                  defaultValue={variant.price}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                      type="text"
                      readOnly
                      placeholder="Selling Price"
                      isInvalid={
                        !!errors?.quantitys?.[weekIndex]?.varients?.[
                          deliveryIndex
                        ]?.selling_price
                      }
                    />
                  )}
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors?.quantitys?.[weekIndex]?.varients?.[deliveryIndex]
                      ?.selling_price?.message
                  }
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label> Stock</Form.Label>
                <Form.Control
                  id={`general-${weekIndex}-${deliveryIndex}`}
                  type="text"
                  placeholder=" Stock"
                  {...register(
                    `quantitys.${weekIndex}.varients.${deliveryIndex}.general_stock`,

                    {
                      required: "Stock is required",
                      validate: (value) =>
                        value.length <= 200 ||
                        "Data must be 200 characters or less",
                    }
                  )}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];

                    if (allowedKeys.includes(e.key) || /^\d$/.test(e.key)) {
                      return;
                    }

                    e.preventDefault();
                  }}
                  isInvalid={
                    !!errors?.quantitys?.[weekIndex]?.varients?.[deliveryIndex]
                      ?.general_stock
                  }
              
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors?.quantitys?.[weekIndex]?.varients?.[deliveryIndex]
                      ?.general_stock?.message
                  }
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

         
          </Row>
        </div>
      ))}
    </>
  );
};

export default VarientSection;
